// Polyfill must be first
import './polyfills';

// TinyMCE
import 'tinymce/tinymce.min';
import 'tinymce/plugins/advlist/plugin.min';
import 'tinymce/plugins/autolink/plugin.min';
import 'tinymce/plugins/link/plugin.min';
import 'tinymce/plugins/lists/plugin.min';
import 'tinymce/plugins/paste/plugin.min';

// Cache config
import { GlobalCacheConfig } from 'ngx-cacheable';
// By default this service only caches for 1 parameter value,
// calling the cached function with a different parameter clears the cache
GlobalCacheConfig.maxCacheCount = Infinity;
